import { memo } from 'react';
import SpinnerNotification, { ESpinnerVariant } from 'components/controls/Notification/SpinnerNotification';
import { ELoadStatus } from 'global/Reducer/statusSlice';

interface ISnapshotNotificationsProps {
    dataSavingStatus: ELoadStatus;
}

/**
 * Component to render saving/processing notifications
 * Memoized to prevent unnecessary re-renders
 */
export const SnapshotNotifications = memo((props: ISnapshotNotificationsProps) => {
    const isHidden = props.dataSavingStatus === ELoadStatus.idle;
    
    const variant = props.dataSavingStatus === ELoadStatus.criticalSaving || props.dataSavingStatus === ELoadStatus.saving
        ? ESpinnerVariant.spinner
        : props.dataSavingStatus === ELoadStatus.complete
            ? ESpinnerVariant.done
            : ESpinnerVariant.default;

    return (
        <SpinnerNotification
            hidden={isHidden}
            variant={variant}
        />
    );
});

SnapshotNotifications.displayName = 'SnapshotNotifications';

export default SnapshotNotifications;
